import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import Navigation from '../../../components/Navigation/Navigation';
import AddressFields from '../../../components/Address/AddressFields';
import { AddressValidator } from '../../../utils/Validators';
import {isMobile} from 'react-device-detect';
import withBackgroundImage from '../../../HOC/withBackgroundImage';
import debounce from 'debounce';

import { updateAddress, updateMailingAddress } from '../../../actions/personalInfoAction';

class Address extends Component {
  constructor(props) {
    super(props);

    this.validator = AddressValidator();

    this.state = {
      address1: this.props.address1 || "",
      address2: this.props.address2 || "",
      city: this.props.city || "",
      province: this.props.province || "BC",
      postalCode: this.props.postalCode || "",
      validation: this.validator.valid(),
      autocompleteValidation: this.autocompleteValidation,
      manualEntry: this.props.manualEntry || false
    }

    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.populateAddressFields = this.populateAddressFields.bind(this);
    this.validateField = this.validateField.bind(this);
    this.setManualEntry = this.setManualEntry.bind(this);
    this.updateAddress = this.updateAddress.bind(this);
    this.updateMailingAddress = this.updateMailingAddress.bind(this);
  }
  setManualEntry(value) {
    // Change manualEntry and reset validation
    this.setState({
      manualEntry: value,
      validation: this.validator.valid(),
      autocompleteValidation: this.autocompleteValidation
    }, () => {
      this.updateAddress();
    });
  }
  onClickForward(event) {
    event.preventDefault();
    if(this.state.manualEntry) {
      // If current or mailing address have been editied during the review, only update the current address
      if(!this.props.individuallySet && !this.props.mailingAddressSet) {
        this.setState({validation: this.validator.validate(this.state)}, () => {
          if(this.state.validation.isValid) {
            this.updateAddress();
            this.updateMailingAddress();
            this.props.history.replace('/PersonalInfo/LivingSituation');
          }
        });
      }
      else {
        this.setState({validation: this.validator.validate(this.state)}, () => {
          if(this.state.validation.isValid) {
            this.updateAddress();
            this.props.history.replace('/PersonalInfo/LivingSituation');
          }
        });
      }
    }
    else {
      // If manual entry is false, show error message
      this.setState({
        autocompleteValidation: {
          homeAddress: {
            isInvalid: true,
            message: "Oops, home address is a required field"
          }
        }
      })
    }
  }
  // PBI 450387 VOA: Remove the 'SIN' optional field from the application form
  onClickBackward() {
    this.props.history.replace('/PersonalInfo/Contact');
  }
  handleChange(event) {
    this.setState({
      validation: {...this.state.validation, [event.target.name]: this.validator.resetFieldValidation(event.target.name)},
      [event.target.name]:event.target.value
    }, () => {
      this.updateAddress();
    });
  }
  populateAddressFields(addressFields) {
    this.setState({...addressFields}, () => {
      this.updateAddress();
    });
  }
  validateField(event) {
    this.setState({
      validation: {...this.state.validation, [event.target.name]: this.validator.validateField(event.target.name, event.target.value)}
    });
  }
  updateAddress = debounce(() => {
    this.props.updateAddress(this.state.address1, this.state.address2, this.state.city, this.state.province, this.state.postalCode, this.state.manualEntry);
  }, 1000);
  updateMailingAddress() {
    this.props.updateMailingAddress(this.state.address1, this.state.address2, this.state.city, this.state.province, this.state.postalCode);
  }
  render() {
    return (
      <div>
        <h1>Where do you live?</h1>
        <Form onSubmit={this.onClickForward}>
          <AddressFields handleChange={this.handleChange} setManualEntry={this.setManualEntry} validateField={this.validateField} populateAddressFields={this.populateAddressFields} {...this.state} autoFocus={!isMobile} />
          <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />
        </Form>
      </div>);
  }
}

const mapStateToProps = state => ({
  ...state.personalInfo.address, mailingAddressSet: (state.personalInfo.mailingAddress && state.personalInfo.mailingAddress.individuallySet) || false
});

const mapDispatchToProps = dispatch => ({
  updateAddress: (address1, address2, city, province, postalCode, manualEntry) => dispatch(updateAddress(address1, address2, city, province, postalCode, manualEntry)),
  updateMailingAddress:  (address1, address2, city, province, postalCode) => dispatch(updateMailingAddress(address1, address2, city, province, postalCode))
});

export default  connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("know-you")(Address));


// WEBPACK FOOTER //
// ./src/containers/PersonalInfo/Address/Address.js